import type { SupabaseClient } from '@supabase/supabase-js'
import type { OnAccessTokenChange } from '@/modules/auth/use-cases'

export class SupabaseOnAccessTokenChangeRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: OnAccessTokenChange = (cb) => {
    const { data } = this.client.auth.onAuthStateChange((_event, session) => {
      cb(session?.access_token ?? null)
    })
    return () => data.subscription.unsubscribe()
  }
}
